import React, {useState} from "react";
import {Alert, Button, Spin} from "antd";
import ExploreQueryBuilder from "../components/QueryBuilder/ExploreQueryBuilder";
import TitleModal from "../components/TitleModal.js";
import {isQueryPresent} from "@cubejs-client/react";
import PageHeader from "../components/PageHeader.js";
import ExploreTitle from "../components/ExploreTitle.js";
import {inject, observer} from "mobx-react";

const tryParse = value => {
    try {
        return JSON.parse(value)
    } catch (e) {
        console.log("parse error", e)
        console.log("parse error-val", value)
        return {}
    }
}

// const ExplorePageSimple = withRouter(({ history, location, loading, error, data }) => {
const ExplorePageSimple = ({ history, params, loading, error, store }) => {
  const [addingToDashboard, setAddingToDashboard] = useState(false);
  const itemId = params.get("itemId");

  const data = {dashboardItem: (store.dashboardItems.filter(item => item.id == itemId)[0]) || {}};
  const [vizState, setVizState] = useState(null);
  const vizStateData = tryParse(data.dashboardItem.vizState)

  const finalVizState =
    vizState ||
    (itemId && !loading && data && (vizStateData ||  {})) || {};
  const [titleModalVisible, setTitleModalVisible] = useState(false);
  const [title, setTitle] = useState(null);
  const finalTitle =
    title != null
      ? title
      : (itemId && !loading && data && data.dashboardItem.name) || "Новый";

  if (loading) {
    return <Spin />;
  }

  if (error) {
    return <Alert type="error" message={error.toString()} />;
  }

  return (
    <div>
      <TitleModal
        history={history}
        itemId={itemId}
        item={data}
        dashboard={store}
        titleModalVisible={titleModalVisible}
        setTitleModalVisible={setTitleModalVisible}
        setAddingToDashboard={setAddingToDashboard}
        finalVizState={finalVizState}
        setTitle={setTitle}
        finalTitle={finalTitle}
      />
      <PageHeader
        title={<ExploreTitle itemId={itemId} />}
        button={
          <Button
            key="button"
            type="primary"
            loading={addingToDashboard}
            disabled={!isQueryPresent(finalVizState.query || {})}
            onClick={() => setTitleModalVisible(true)}
          >
            {itemId ? "Обновить" : "Добавить"}
          </Button>
        }
      />
      <ExploreQueryBuilder
        vizState={finalVizState}
        setVizState={setVizState}
      />
    </div>
  );
};

const ExplorePage = inject('dashboard')(observer(({ dashboard, history, location, match }) => {
    const params = new URLSearchParams(location.search);
    const wd = match.params.wd
    dashboard.insureServer(wd)
    return (<ExplorePageSimple  history={history} params={params} location={location} store={dashboard} />)
}))



export default ExplorePage;
